// THIS IS ALSO USED BY COMPANY VARIANT BLOCK
// shadowed by Wijnne

import React from 'react';
import styled from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import Button from 'gatsby-theme-core/src/components/button/index';

const Wrapper = styled.div``;

// shadowed by Wijnne
export const Title = styled.h3`
  margin: 0 0 .25rem 0;
  font-size: 1.375rem;
  color: ${({ theme }) => theme.primaryColor};
`;

const P = styled.p`
  font-weight: 300;
  font-size: 1rem;
  margin: 0;
`;

const Inner = styled.div`
  flex-grow: 1;
  padding: 1.5rem 1.5rem;
  text-align: center;
`;

const StyledButton = styled(Button).attrs({ wrapper: true })`
  gap: 0;
  &:hover {
    background-color: ${({ theme }) => theme.primaryColor};
    &, ${Title} {
      color: white;
    }
  }
`;
const BlockHighlight = ({
  className,
  image,
  title,
  subtitle,
  toPage,
  link,
  children,
}) => {
  const to = toPage?.slug ?? link;

  return (
    <Wrapper className={className} as={to ? StyledButton : 'div'} to={to}>
      {image?.localFile?.childImageSharp && <Image image={image} loading="lazy" />}
      <Inner>
        {title && <Title>{title}</Title>}
        {subtitle && <P>{subtitle}</P>}
        {children} {/* used by Pagebuilder Company variant block */}
      </Inner>
    </Wrapper>
  );
};

export default styled(BlockHighlight)`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
  color: ${({ theme }) => theme.fontColor};
  text-decoration: none;
  border-radius: ${({ theme }) => theme.borderRadius};
  font-weight: bold;
  border: solid 1px #c3c9d5;

  ${Image} {
    border-radius: calc(-1px + 0.25rem) calc(-1px + 0.25rem) 0 0;
    max-width: 100%;
  }
`;
